"use client";
import { Children, useRef } from "react";
import "./flutter-carousel.css";

export default function FlutterCarousel({ children }) {
  const strip = useRef(null);
  const cards = Children.toArray(children).slice(0, 10);
  return <div className="flutter-carousel">
    <div ref={strip} className="flutter-carousel-strip" tabIndex={0} aria-label="Stories from Flutter members">
      {cards.map((card, index) => <div className="flutter-carousel-card" key={card.key || index}>{card}</div>)}
    </div>
    {cards.length > 1 && <button type="button" className="flutter-carousel-next" aria-label="Next Flutter stories" onClick={() => {
      const element = strip.current;
      const atEnd = element.scrollLeft + element.clientWidth >= element.scrollWidth - 2;
      element.scrollTo({ left: atEnd ? 0 : element.scrollLeft + element.clientWidth, behavior: "smooth" });
    }}>→</button>}
  </div>;
}
